<template>
    <div>
        <div @click="back" class="header border-bottom">
            <i class="iconfont">&#xe604;</i>
        </div>
        <div class="content">
            <div>
              <p>已验证手机：{{list.tel}}</p>
            </div>
            <div  class="login_list">
              <span v-show="sendAuthCode" class="auth_text auth_text_blue"  @click="getAuthCode">获取短信验证码</span>
              <span v-show="!sendAuthCode" class="auth_text"> <span class="auth_text_blue">{{auth_time}} </span> 秒后再获取</span>
              <input class="auth_input" type="text"  placeholder="请输入手机验证码" v-model="PhoneCode"/>
            </div>
        </div>
        <button @click="handleCodePostClick">下一步</button>
    </div>
</template>

<script>
export default {
  name: 'ValidateMess',
  props: {
    list: Object
  },
  data () {
    return {
      sendAuthCode: true,
      auth_time: 0,
      PhoneCode: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    getAuthCode () {
      this.axios.post('/ApiSms/UpdatePayPwdSendCode', {
        phone: this.list.tel
      }).then(this.handlePostSuccInfo)
        .catch(this.handlePostFailInfo)
      this.sendAuthCode = false
      this.auth_time = 60
      var timer = setInterval(() => {
        this.auth_time--
        if (this.auth_time <= 0) {
          this.sendAuthCode = true
          clearInterval(timer)
        }
      }, 1000)
    },
    handlePostSuccInfo (res) {
      res = res.data
      if (res.ret) {
        alert(res.errorInfo)
      }
    },
    handlePostFailInfo (res) {
      res = res.data
      if (res.ret) {
        alert(res.errorInfo)
      }
    },
    handleCodePostClick () {
      this.axios.post('/ApiMe/VerifyPaySafety', {
        PhoneCode: this.PhoneCode
      }).then(this.handleCodeSuccInfo)
        .catch(this.handleCodeFailInfo)
    },
    handleCodeSuccInfo (res) {
      res = res.data
      if (res.ret) {
        if (res.errorInfo === '') {
          this.$router.push({
            path: '/revise_pay_password',
            query: {
              code: res.data.code
            }
          })
        } else if (res.errorInfo.indexOf('触发小时') >= 0) {
          alert('获取验证码操作频繁，请稍候再试')
        } else {
          alert(res.errorInfo)
        }
      }
    },
    handleCodeFailInfo (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px;}
.header .iconfont{ font-size: 25px;}
.content{ padding: 0 15px;}
.content p{ padding: 15px 0;}
.content input{ padding: 13px 0; font-family: Arial,"Microsoft YaHei";}
input::-webkit-input-placeholder{ color:#b6b6b6; padding: 5px 0; font-size: 14px; line-height: 5px; font-family: Arial,"Microsoft YaHei";}
.auth_text{ border: 1px solid #ed2727; color: #ed2727; padding: 10px 5px; border-radius: 3px; float: right;}
button{ font-family: Arial,"Microsoft YaHei"; background: #ed2727; border: 0; color: #fff; width: 80%; display: block; margin: 0 auto; padding: 7px 0; font-size: 14px; border-radius: 3px; margin-top: 25px;}
</style>



// WEBPACK FOOTER //
// src/pages/revise_pay_password_validate/components/Mess.vue